import { JsonServiceClient } from '@servicestack/client';
import { useMemo } from 'react';
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { client } from '../api/client';
import { GetMembershipStatus, GetMembershipStatusResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetMembershipStatusResponse, GetMembershipStatusResponse>) => response?.data?.type;

const getError = (response?: SWRResponse<GetMembershipStatusResponse, GetMembershipStatusResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetMembershipStatusResponse, GetMembershipStatusResponse>) => ({
    membershipType: response?.data?.type,
    registered: response?.data?.registered
});

export const useMembershipStatus = (firstName?: string, lastName?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!firstName || !lastName) {
            return undefined;
        }
        
        return () => {
            return new GetMembershipStatus({firstName, lastName});
        };
    }, [firstName, lastName])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useMembershipStatus;
